angular.module("vgresiduos").controller("DocumentCreateCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			const params = [{ key: "documentType", value: $stateParams.documentType }];
			if ($stateParams.documentRequestId) {
				params.push({ key: "documentRequestId", value: $stateParams.documentRequestId });
			}
			Vgr.util.redirectSingleton($rootScope, `fornecedor/documento`, params);
		};
	}
]);
